import type { PermissionRow } from '../../platformadmin/framework';

type Props = { permissions?: PermissionRow[] };

export function PermissionEnginePanel({ permissions = [] }: Props) {
  return (
    <div className="space-y-3">
      {permissions.map((p) => {
        const pct = Math.round((p.granted / p.total) * 100);
        return (
          <div key={p.scope}>
            <div className="flex items-center justify-between text-xs">
              <span className="font-medium">{p.scope}</span>
              <span className="text-slate-500">{p.granted}/{p.total} ({pct}%)</span>
            </div>
            <div className="mt-1 h-2 rounded-full bg-slate-100 dark:bg-slate-800">
              <div className="h-2 rounded-full bg-brand-500" style={{ width: `${pct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
